import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Blog from './pages/Blog';
import Contact from './pages/Contact';

import logoImage from './assets/images/UP_logo.jpg';

function App() {
    const [menuOpen, setMenuOpen] = useState(false);  // Manage hamburger menu state

    // Toggle the menu visibility
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <Router>
            <div className="App">
                <nav>
                    {/* Brand logo */}
                    <div className="logo">
                        <Link to="/">
                            <img src={logoImage} alt="Logo" />
                        </Link>
                    </div>

                    {/* Hamburger Icon (visible on small screens) */}
                    <button className="hamburger" onClick={toggleMenu}>
                        <div></div>
                        <div></div>
                        <div></div>
                    </button>

                    {/* Navbar links (visible on large screens and when menu is open on small screens) */}
                    <div className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
                        <ul>
                            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
                            <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
                            <li><Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link></li>
                            <li><Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link></li>
                            <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
                        </ul>
                    </div>
                </nav>

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/contact" element={<Contact />} />
                </Routes>

                <footer className="App-footer">
                    <p>&copy; 2025 Unpager. All rights reserved.</p>
                </footer>
            </div>
        </Router>
    );
}

export default App;
